'use strict';

require('./local.styl');
require('../../../modules/merchant/frontend/lazy_load');
require('../../../modules/ugc_photos/frontend/main');
require('../../../modules/cash_back/desktop_2016/frontend/cash_back');
require('../../../modules/deal/frontend/glive_booking_wrapper');
require('../../../modules/deal/desktop_2016/frontend/sticky_purchase_cluster');
require('../../../modules/juice_program/frontend/juice_program');
require('../../../modules/menu/frontend/desktop_menu');

// script to separate Js in chunks and load async modules
require('./async_scripts/local');



// WEBPACK FOOTER //
// ./core/frontend/webpack/local.js